export default __webpack_public_path__ + "static/media/KAAN03.05e41d07.png";